import { Injectable } from '@angular/core';
import { GlobalHttpClient } from '../global.http.client';
import { CmsPageType } from '../models/cms.pages/cms.pages.models';
import { BaseService } from './base.service';

@Injectable()
export class CmsPageService extends BaseService {
    constructor(http: GlobalHttpClient) {
        super(http);
    }

    getByType(pageType: CmsPageType) {
        return this.http.get(`cmsPages/${pageType}`);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/cms.page.service.ts